// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__qiFASQC1","loader":"Loader_loader__C3Tz7SG1","loaderAnimation":"Loader_loaderAnimation__unZFSE8y"};